import { render, staticRenderFns } from "./companyDes.vue?vue&type=template&id=7e447215&scoped=true&"
import script from "./companyDes.vue?vue&type=script&lang=js&"
export * from "./companyDes.vue?vue&type=script&lang=js&"
import style0 from "./companyDes.vue?vue&type=style&index=0&id=7e447215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e447215",
  null
  
)

export default component.exports